import { isMobile } from 'react-device-detect';

export function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0;
}

export function getCoverImg(product, color) {
  let images = product ? product.images : [];
  let result = images.filter(image => !(image.altText && image.altText.includes(`#not_in_cover`)));
  if (isMobile) {
    result = result.filter(image => !(image.altText && image.altText.includes(`#not_in_mobile`)));
  } else {
    result = result.filter(image => !(image.altText && image.altText.includes(`#not_in_desktop`)));
  }
  for (let img of result) {
    if (img.altText && img.altText.includes(`#color_${color}`)) {
      return img;
    }
  }
  return result[0] || {};
}

export function getVariantUSDSubtotalByLineItem(lineItem, product) {
  const variant = product?.variants?.find(v => v.id === lineItem.variant.id);
  if (!variant) {
    return '-'; // Product Variant Not Found. Price error.';
  }

  const price = parseFloat(variant.price.amount);
  if (isNaN(price)) {
    return 'Invalid price amount.';
  }

  const quantity = lineItem.quantity || 1; // Default to 1 if quantity is missing
  const subtotalInCents = Math.round(price * 100) * quantity;
  const subtotalInUSD = subtotalInCents / 100;
  return subtotalInUSD.toFixed(2); // Returns string with 2 decimals, e.g., "25.98"
}

export function getCartUSDPriceByCartAndProductList(cart, products) {
  if (!cart?.lineItems || !Array.isArray(products)) {
    return "-"; // "Invalid cart or products data";
  }
  const totalInCents = cart.lineItems
    .map((item) => {
      // Search for the variant across all products' variants arrays
      let matchedVariant = null;
      for (const product of products) {
        if (product?.variants) {
          matchedVariant = product.variants.find(v => v.id === item.variant.id);
          if (matchedVariant) break; // Stop searching once found
        }
      }

      // Handle case where no variant is found
      if (!matchedVariant) {
        console.warn(`Product Variant Not Found for ID: ${item.variant.id}`);
        return "Invalid product variant";
      }

      // Convert price string to cents
      const price = parseFloat(matchedVariant.price.amount);
      if (isNaN(price)) {
        console.warn(`Invalid price for variant ID: ${item.variant.id}`);
        return "Invalid variant price";
      }

      return Math.round(price * 100) * (item.quantity || 1);
    })
    .reduce((sum, price) => sum + price, 0);

  // Convert back to dollars
  const totalInUSD = totalInCents / 100;
  return totalInUSD.toFixed(2);
}
